import React from "react";
import { CategoriesTypeRequest } from "../../../common/types/Casino/CategoriesType";
import "./CategoriesList.scss";

interface ICategoriesList {
  categoriesList: CategoriesTypeRequest | undefined;
  categoryIdSelected: string;
  setCategoryIdSelected: React.Dispatch<React.SetStateAction<string>>;
}

const CategoriesList = ({
  categoriesList,
  categoryIdSelected,
  setCategoryIdSelected,
}: ICategoriesList) => {
  const handleSelectCategory = (item: string) => {
    setCategoryIdSelected(item);
  };
  return (
    <div className="casino-category-chooser-container">
      <div
        className="horizontal-sl-list-container"
        data-scroll-lock-scrollable=""
      >
        <div className="horizontal-sl-list casino-horizontal-sl-list-bc">
          {categoriesList
            ? Object.keys(categoriesList)?.map((index) => {
                return (
                  <div
                    className={`horizontal-sl-item-bc newgames ${
                      categoryIdSelected === categoriesList[index].slug
                        ? "active"
                        : ""
                    }`}
                    data-id={287}
                    title={categoriesList[index].name}
                    key={categoriesList[index].id}
                    onClick={() =>
                      handleSelectCategory(categoriesList[index].slug)
                    }
                  >
                    {categoriesList[index].id === 6 ? (
                      <i className="horizontal-sl-icon-bc bc-i-default-icon bc-i-all-games" />
                    ) : null}
                    <p className="horizontal-sl-title-bc">
                      {categoriesList[index].name}
                    </p>
                  </div>
                );
              })
            : null}
        </div>
      </div>
    </div>
  );
};

export { CategoriesList };
